import { Injectable, inject } from '@angular/core';

import { MediaAdapter } from '@modules/content-api/adapter/media.adapter';
import { PreMediaLightboxImageStyle } from '@modules/content-api/domain/image-styles/pre-media-detail-image.style';
import { MediaImageFormatInterface, MediaImageInterface } from '@modules/media/models/media-image.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PreMediaImageHelper {
  private mediaAdapter = inject(MediaAdapter);

  public parseImageWithWatermark(imageData: any, displayStyle: any, context: any, slug = ''): MediaImageInterface {
    const parsedImage =
      imageData.type === 'structured_image'
        ? this.mediaAdapter.parseStructuredImage(imageData, displayStyle, context, slug)
        : this.mediaAdapter.parseImage(imageData, displayStyle, context, slug);

    const imageId = this.getImageId(imageData);
    if (imageId) {
      parsedImage.lightboxFormats = this.buildLightboxFormats(imageId);
    }

    return parsedImage;
  }

  private getImageId(imageData: any): string | null {
    return (
      imageData.image?.id || imageData.relationships?.image?.id || imageData.relationships?.adjusted_image?.id || null
    );
  }

  private buildLightboxFormats(imageId: string): MediaImageFormatInterface[] {
    return PreMediaLightboxImageStyle.map((setting) => ({
      id: `${setting.key}`,
      url: `${environment.mediaDeliveryUrl}/${imageId}/${setting.key}`,
      filename: '',
      mimeType: 'image/jpeg',
      height: setting.height,
      width: setting.width,
      minWidth: setting.screen.toString(),
      filesize: 0,
      landscapeOnly: setting.landscapeOnly,
    }));
  }
}
